export enum ProductBannerImageWithTextStyle {
  THIN = 'thin',
  WIDE = 'wide',
}
